import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { AppShell } from '@/app/app-shell'
import { OverviewPage } from '@/pages/overview/overview-page'
import { ReportPage } from '@/pages/report/report-page'
import { SessionsPage } from '@/pages/sessions/sessions-page'
import { CustomersPage } from '@/pages/settings/customers/customers-page'
import { DataSettingsPage } from '@/pages/settings/data/data-settings-page'
import { PeoplePage } from '@/pages/settings/people/people-page'
import { ProjectsPage } from '@/pages/settings/projects/projects-page'
import { TimesheetPage } from '@/pages/timesheet/timesheet-page'

// Project details now open in a side panel on the Projects page.
function ProjectRedirect(): React.JSX.Element {
  const { projectId } = useParams()
  return <Navigate to={`/projects?project=${projectId}`} replace />
}

export function AppRouter(): React.JSX.Element {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/project-sheet" element={<TimesheetPage />} />
        <Route path="/budgets" element={<OverviewPage />} />
        <Route path="/reports" element={<ReportPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectRedirect />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/clients" element={<CustomersPage />} />
        <Route path="/data" element={<DataSettingsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/timesheet" element={<Navigate to="/project-sheet" replace />} />
        <Route path="/overview" element={<Navigate to="/budgets" replace />} />
        <Route path="/report" element={<Navigate to="/reports" replace />} />
        <Route path="/settings/projects" element={<Navigate to="/projects" replace />} />
        <Route path="/settings/projects/:projectId" element={<ProjectRedirect />} />
        <Route path="/settings/people" element={<Navigate to="/people" replace />} />
        <Route path="/settings/clients" element={<Navigate to="/clients" replace />} />
        <Route path="/settings/data" element={<Navigate to="/data" replace />} />
        <Route path="*" element={<Navigate to="/project-sheet" replace />} />
      </Route>
    </Routes>
  )
}
